module.exports = "<span class=foundry-attributions> <a href=https://www.nrcan.gc.ca/ target=_blank>© NRCan</a> | <a title=\"Mapping by Foundry Spatial\" href=https://foundryspatial.com/ target=_blank> Foundry Spatial <img alt=\"Foundry Spatial\" class=foundry-spatial-logo src=" + require("./foundrySpatialLogo.svg") + " /> </a> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/map/attribution.html
// module id = 30
// module chunks = 0